import { j as Be } from "../../../../jsx-runtime.BREq8dyb.js";
import { Key as Ie, LabeledPromise as Ue, exceptions as Me, ProgressPromise as Ve } from "@decentriq/utils";
import { m as xe } from "../../../../lodash.CbaCmyiN.js";
import { memo as qe, useState as h, useMemo as ae, useEffect as Fe, useCallback as Oe } from "react";
import { getLatestVersionedSchema as Ge } from "../../utils/index.js";
import { PromiseState as F } from "../../../Loader/Loader.js";
import { DatasetProvider as Je } from "../../contexts/DatasetContext/DatasetContext.js";
import "../../contexts/FeatureContext/FeatureContext.js";
import { useFile as Ke } from "../../contexts/FileContext/FileContext.js";
import { useIntrospection as Qe } from "../../contexts/IntrospectionContext/IntrospectionContext.js";
import { useNavigator as Xe } from "../../contexts/NavigatorContext/NavigatorContext.js";
import { useOptions as Ye } from "../../contexts/OptionsContext/OptionsContext.js";
import { useSchema as Ze } from "../../contexts/SchemaContext/SchemaContext.js";
import { useTypifycation as eo } from "../../contexts/TypificationContext/TypificationContext.js";
import { useWorker as oo } from "../../contexts/WorkerContext/WorkerContext.js";
import { TableColumnFormatType as ne } from "@decentriq/graphql/dist/enums";
import { useErrorHandler as to } from "../../handlers/ErrorHandler/ErrorHandler.js";
const se = "Uploading…", _e = "Uploaded", ie = "Upload failed", ro = "Dataset is getting encrypted locally and transmitted…", ao = "Dataset encrypted and transmitted successfully", no = "Failed to encrypt and transmit dataset", so = qe(({
  initArguments: le,
  children: $e,
  onBeforeUpload: W,
  onAfterUpload: z,
  uploadDatasetFulfilledLabel: ce = ao,
  uploadDatasetPendingLabel: de = ro,
  uploadDatasetRejectedLabel: ue = no
}) => {
  const fe = to(), {
    currentStep: G
  } = Xe(), {
    schema: ke
  } = Ze(), {
    columns: s,
    uniqueColumnIds: R
  } = ke || {}, {
    file: E,
    fileEncoding: S,
    fileHasHeader: O,
    fileHeaders: pe,
    fileValuesDelimiter: _,
    fileDecimalSeparator: H
  } = Ke(), {
    introspecting: J
  } = Qe(), {
    typifying: K
  } = eo(), {
    autofix: f,
    dropFailedRows: y,
    hashedColumns: g,
    mappedColumns: u,
    mapping: me,
    showRows: Q
  } = Ye(), {
    analyzeDataset: j,
    uploadDataset: X
  } = oo(), [he, ve] = h(!1), [i, B] = h(void 0), [ye, I] = h(), [D, M] = h(!1), [ge, p] = h(), [we, L] = h(void 0), [Ae, P] = h(void 0), [Ee, U] = h(), [Le, Y] = h(void 0), [be, Z] = h(void 0), {
    autofix: Ne,
    statistics: We,
    validation: ze
  } = i || {}, {
    numRows: $
  } = We || {}, {
    report: Se
  } = Ne || {}, {
    progressTotal: Ce,
    report: He,
    rows: ee
  } = ze || {}, {
    report: oe
  } = He || {}, te = Array.isArray(pe) && pe.length > 0, b = Array.isArray(s) && s.length > 0, l = ae(() => ({
    config: {
      columns: s?.map((e, o) => (
        // NOTE: Skipping validation errors until the "Fix values" step
        G < 2 ? {
          allowNull: !0,
          default: e.default,
          formatType: ne.String,
          hashWith: G < 1 ? void 0 : e.hashWith,
          name: e.name
        } : {
          allowNull: e.nullable,
          default: e.default,
          formatType: e.hashWith ? g.includes(o) ? e.formatType : ne.HashSha256Hex : e.formatType,
          hashWith: e.hashWith,
          name: e.name
        }
      )) || [],
      ...Array.isArray(R) && R.length > 0 && Array.isArray(s) && s.length > 0 ? {
        table: {
          uniqueness: {
            uniqueKeys: R?.map((e) => ({
              columns: e?.map((o) => s.findIndex(({
                id: w
              }) => w === o))
            }))
          }
        }
      } : {}
    },
    version: "v0"
  }), [s, G, g, R]);
  Fe(() => {
    B(void 0), I(void 0);
  }, [j, f, E, O, _, b, te, g, u, l, Q, J, K]);
  const V = Oe(async (e = void 0, o = void 0) => {
    if (j && E && b && te && !J && !K && !me && !D)
      try {
        o?.() && (B(void 0), I(void 0), ve(!0));
        const r = l.config.columns.filter((m, A) => u[A] !== void 0), w = g.filter((m) => u[m] !== void 0 && r[m]?.hashWith !== void 0), x = {
          autofix: f,
          decimalSeparator: H,
          prepareCsvOptions: {
            columns: r
          },
          validateCsvOptions: {
            hashColumns: w,
            numRowsToRecordForPreview: 1e4,
            previewRowFilter: Q,
            recordPreview: !0,
            stopAtValidationFailure: !1,
            validationConfig: {
              ...l,
              config: {
                ...l.config,
                columns: r
              }
            }
          }
        }, k = {
          delimiter: _,
          encoding: S,
          hasHeader: O,
          keepOnlyColumns: u.length > 0 ? u.reduce((m, A) => (A !== void 0 && m.push(A), m), []) : void 0
        }, q = await j(xe({
          analyzeCsvOptions: x,
          file: E,
          parseCsvOptions: k
        }, e));
        return o?.() && (I(void 0), B(q)), q;
      } catch (r) {
        switch (r) {
          case "Aborted by user":
            break;
          default:
            o?.() && (B(void 0), I(r));
            break;
        }
      } finally {
        o?.() && ve(!1);
      }
  }, [j, f, E, H, S, O, _, b, te, g, J, u, me, Q, K, D, l]), re = (e) => {
    L(void 0), p(se);
    const o = e();
    return o instanceof Ve && o.progress((r) => {
      L(Math.round(r * 100));
    }), o instanceof Ue && (p(o.pendingLabel || se), o.then((r) => (p(o.fulfilledLabel || _e), r), void 0).catch((r) => {
      p(o.rejectedLabel || ie);
    })), o;
  }, Te = Oe(async (e = void 0, o = void 0) => {
    if (X && E && !D)
      try {
        P(void 0), U(void 0), L(void 0), p(se), M(!0);
        const r = {
          delimiter: _,
          encoding: S,
          hasHeader: O,
          keepOnlyColumns: u.length > 0 ? u.reduce((t, c) => (c !== void 0 && t.push(c), t), []) : void 0
        }, w = b ? {
          fileType: "csv",
          parseCsvOptions: r
        } : {
          fileType: "raw"
        }, x = new Ie(), k = {
          description: void 0,
          statistics: void 0
        }, Pe = b && f ? {
          config: {
            columns: s.map((t) => t.formatType) || [],
            decimalSeparator: H
          },
          version: "v0"
        } : void 0, q = b ? {
          autofixConfig: Pe,
          dropFailedRows: y,
          hashColumns: g,
          validationConfig: l
        } : void 0, m = {
          file: E,
          fileOptions: w,
          initArguments: le,
          key: x,
          prepareCsvOptions: {
            columns: s?.map((t, c) => ({
              allowNull: t.nullable,
              default: t.default,
              formatType: t.hashWith ? g.includes(c) ? t.formatType : ne.HashSha256Hex : t.formatType,
              hashWith: t.hashWith,
              name: t.name
            })) || []
          },
          progressTotal: Ce,
          uploadId: `upload-${(/* @__PURE__ */ new Date()).toISOString()}`,
          uploadOptions: k,
          validation: q
        };
        if (Array.isArray(W) && W.length > 0)
          for (const [t, c] of W.entries())
            if (c instanceof Function) {
              const n = re(c.bind(null, m));
              let a = n?.pendingLabel, v, T = F.Pending;
              try {
                v = await n, T = F.Fulfilled, a = n?.fulfilledLabel;
              } catch (d) {
                throw T = F.Rejected, a = n?.rejectedLabel, v = d?.result, d || new Error(`Unknown error: ${a}`);
              } finally {
                Y((d = []) => {
                  if (a || v) {
                    const N = [...d];
                    return N[t] = {
                      label: a,
                      result: v,
                      state: T
                    }, N;
                  } else
                    return d;
                });
              }
            } else {
              const n = new Error(`onBeforeUpload[${t}] is not a function`);
              throw P(null), U(n), p(ie), new Error(`onBeforeUpload[${t}] is not a function`);
            }
        const A = await re(() => {
          const t = new Ue(async (c, n) => {
            try {
              const a = await X(xe(m, e), L || o);
              c(a);
            } catch (a) {
              switch (a) {
                case "Aborted by user":
                  break;
                default:
                  n(a);
              }
            }
          });
          return t.pendingLabel = de, t.fulfilledLabel = ce, t.rejectedLabel = ue, t;
        });
        if (Array.isArray(z) && z.length > 0)
          for (const [t, c] of z.entries())
            if (c instanceof Function) {
              const n = re(c.bind(null, m, A, s ? Ge({
                columns: s,
                uniqueColumnIds: R
              }) : void 0));
              let a = n?.pendingLabel, v, T = F.Pending;
              try {
                v = await n, T = F.Fulfilled, a = n?.fulfilledLabel;
              } catch (d) {
                throw T = F.Rejected, a = n?.rejectedLabel, v = d instanceof Me.DatasetValidationError ? d?.report : "", d || new Error(`Unknown error: ${a}`);
              } finally {
                Z((d = []) => {
                  if (a || v) {
                    const N = [...d];
                    return N[t] = {
                      label: a,
                      result: v,
                      state: T
                    }, N;
                  } else
                    return d;
                });
              }
            } else {
              const n = new Error(`onAfterUpload[${t}] is not a function`);
              throw P(null), U(n), p(ie), new Error(`onAfterUpload[${t}] is not a function`);
            }
        return P(A), p(_e), A;
      } catch (r) {
        U(r), fe?.(r);
      } finally {
        L(void 0), M(!1);
      }
  }, [f, s, y, E, H, S, O, _, fe, b, g, le, u, z, W, Ce, X, ce, de, ue, D, l, R]), C = oe?.columns.map((e) => e.numErrorsTotal || 0).flat().reduce((e, o) => e + o, 0) || 0, Re = Se?.columnModifications.map((e) => e.numModificationsTotal || 0).flat().reduce((e, o) => e + o, 0) || 0, De = ae(() => {
    let e;
    if (i) {
      if (y)
        return e = void 0, e;
      if ((ee?.at(0)?.original?.length || 0) < l.config.columns.filter((o) => o.default === void 0).length)
        return e = "The selected file has fewer columns than the table schema. Please check the column separator below or select another file.", e;
      if ($ && $ > 0 && (C || 0) > 0)
        return e = `There ${C !== 1 ? "are" : "is"} ${C} error${C !== 1 ? "s" : ""}.
Please hover over the red cells for more details about the error.`, e += oe?.columns?.reduce((o, r) => {
          const {
            column: w,
            numErrorsTotal: x
          } = r, k = l.config.columns.at(w)?.name || `Column ${w + 1}`;
          return o += `
● Column "${k}" has ${x} error${x !== 1 ? "s" : ""}.`, o;
        }, ""), e += !f && !y ? `
Please check the "Fix failed values" and/or "Drop failed rows" options below or select another file.` : !f && y ? `
Please check the "Fix failed values" option below or select another file.` : f && !y ? `
Please check the "Drop failed rows" option below or select another file.` : f && y ? `
Please select another file.` : "", e;
      if ($ && $ > 0 && (ee?.at(0)?.preview || []).length < (l.config.columns.length || 0))
        return e = `Not all columns have been mapped. Please select the corresponding table column for ${l.config.columns.map((o, r) => u.at(r) === void 0 ? `"${o?.name || `Column ${r + 1}`}"` : void 0).filter(Boolean).join(", ")}.`, e;
    }
    return e;
  }, [i, f, y, u, C, $, ee, l.config.columns, oe?.columns]);
  Fe(() => {
    let e = !0;
    return V(void 0, () => e), () => {
      e = !1;
    };
  }, [V]);
  const je = ae(() => ({
    afterUploadResults: be,
    analyze: V,
    analyzeError: ye,
    analyzeResult: i,
    analyzing: he,
    autofixReport: i?.autofix,
    beforeUploadResults: Le,
    numCells: i?.statistics?.numCells,
    numErrorsTotalSum: C,
    numModificationsTotalSum: Re,
    numNullCells: i?.statistics?.numNullCells,
    numRows: i?.statistics?.numRows,
    numRowsWithNullCell: i?.statistics?.numRowsWithNullCell,
    rows: i?.validation?.rows,
    setAfterUploadResults: Z,
    setBeforeUploadResults: Y,
    setUploadError: U,
    setUploadLabel: p,
    setUploadProgress: L,
    setUploadResult: P,
    setUploading: M,
    upload: Te,
    uploadError: Ee,
    uploadLabel: ge,
    uploadProgress: we,
    uploadResult: Ae,
    uploading: D,
    validationError: De,
    validationReport: i?.validation?.report
  }), [be, V, Re, ye, i, C, he, Z, Y, U, p, L, P, M, Te, we, Ae, D, Ee, ge, Le, De]);
  return /* @__PURE__ */ Be.jsx(Je, { value: je, children: $e });
});
so.displayName = "DatasetContainer";
export {
  so as default
};
//# sourceMappingURL=DatasetContainer.js.map
